import type { SupportedLocaleType } from '@pushflow/constants'
import type { I18nLocalizationType } from '../../types'

export const loadLocalizationResources = async (
  language: SupportedLocaleType,
): Promise<I18nLocalizationType> => {
  switch (language) {
    case 'ru':
      return (await import('../ru')).ru
    case 'pt':
      return (await import('../pt')).pt
    default:
      return (await import('../en')).en
  }
}
